const stages = [
  {
    number: '01',
    icon: 'ri-server-line',
    badge: 'Техническая оптимизация',
    title: 'Внутренняя «гигиена» сайта',
    description: 'Мы следим за тем, чтобы сайт был технически безупречен в глазах поисковиков.',
    color: 'bg-[#1A2B4C]',
    accentColor: '#C5A880',
    points: [
      {
        icon: 'ri-eye-line',
        title: 'Контроль индексации',
        text: 'Проверяем, видят ли роботы ваши новые страницы и не появились ли на сайте «мусорные» разделы, которые тянут рейтинг вниз.',
      },
      {
        icon: 'ri-bug-line',
        title: 'Исправление ошибок',
        text: 'Устраняем битые ссылки и дубли страниц, чтобы клиент не попадал на «страницу 404» вместо товара.',
      },
    ],
  },
  {
    number: '02',
    icon: 'ri-file-text-line',
    badge: 'Тексты, которые продают',
    title: 'Оптимизация контента',
    description: 'Текст на сайте должен нравиться и людям, и поисковым роботам.',
    color: 'bg-[#253D6B]',
    accentColor: '#C5A880',
    points: [
      {
        icon: 'ri-magic-line',
        title: 'Актуализация смыслов',
        text: 'Мы корректируем заголовки и описания (мета-теги Title и Description), чтобы ваш сайт в поиске выглядел привлекательнее, чем у конкурентов.',
      },
      {
        icon: 'ri-route-line',
        title: 'Распределение запросов',
        text: 'Мы следим, чтобы каждая страница отвечала на конкретный запрос клиента, повышая шансы на целевой звонок.',
      },
    ],
  },
  {
    number: '03',
    icon: 'ri-image-2-line',
    badge: 'Оптимизация изображений',
    title: 'Визуальный комфорт',
    description: 'Тяжелые картинки — главная причина ухода клиентов (они просто не дожидаются загрузки).',
    color: 'bg-[#1A2B4C]',
    accentColor: '#C5A880',
    points: [
      {
        icon: 'ri-speed-up-line',
        title: 'Ускорение загрузки',
        text: 'Мы оптимизируем вес всех новых фото и видео без потери качества.',
      },
      {
        icon: 'ri-search-eye-line',
        title: 'Поиск по картинкам',
        text: 'Настраиваем специальные теги (Alt), чтобы клиенты могли найти ваш бизнес через поиск по изображениям.',
      },
    ],
  },
  {
    number: '04',
    icon: 'ri-cursor-line',
    badge: 'UX-оптимизация',
    title: 'Юзабилити: Делаем сайт удобным',
    description: 'На основе данных Яндекс.Метрики и Вебвизора мы анализируем, где клиенты «спотыкаются».',
    color: 'bg-[#253D6B]',
    accentColor: '#C5A880',
    points: [
      {
        icon: 'ri-bar-chart-box-line',
        title: 'Анализ поведения',
        text: 'Мы видим, на каких кнопках люди уходят, и исправляем это.',
      },
      {
        icon: 'ri-shopping-cart-2-line',
        title: 'Упрощение пути к покупке',
        text: 'Делаем формы короче, а навигацию — понятнее. Чем меньше кликов до заказа, тем выше ваша прибыль.',
      },
    ],
  },
];

export default function SupportWorkStages() {
  return (
    <section id="work-stages" className="py-14 sm:py-24 bg-[#F9F5EF] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/10 border border-[#1A2B4C]/20 mb-4 sm:mb-6">
            <i className="ri-list-check-2 text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Ежемесячный план работ
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 sm:mb-6 leading-tight">
            Что конкретно мы делаем каждый месяц
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-4 sm:mb-6 rounded-full"></div>
          <p className="text-sm sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed font-['Montserrat']">
            Прозрачный процесс: вы всегда знаете, над чем мы работаем и какой результат получаете.
          </p>
        </div>

        {/* Stages */}
        <div className="space-y-5 sm:space-y-8">
          {stages.map((stage, idx) => (
            <div
              key={idx}
              className={`${stage.color} rounded-2xl sm:rounded-3xl overflow-hidden`}
            >
              <div className="p-5 sm:p-10">
                {/* Stage header */}
                <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 mb-6 sm:mb-8">
                  {/* Number + Icon */}
                  <div className="flex items-center gap-4 flex-shrink-0">
                    <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl bg-[#C5A880]/20 border border-[#C5A880]/30 flex items-center justify-center flex-shrink-0">
                      <i className={`${stage.icon} text-xl sm:text-3xl text-[#C5A880]`}></i>
                    </div>
                    <div className="sm:hidden">
                      <div className="text-[#C5A880] text-xs font-bold font-['Montserrat'] tracking-widest uppercase mb-1">
                        Этап {stage.number} — {stage.badge}
                      </div>
                      <h3 className="text-base font-bold text-white font-['Playfair_Display'] leading-snug">
                        {stage.title}
                      </h3>
                    </div>
                  </div>

                  <div className="hidden sm:block flex-1 min-w-0">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] tracking-widest uppercase">
                        Этап {stage.number}
                      </span>
                      <span className="inline-block px-3 py-1 rounded-full bg-[#C5A880]/20 border border-[#C5A880]/30 text-[#C5A880] text-xs font-semibold font-['Montserrat']">
                        {stage.badge}
                      </span>
                    </div>
                    <h3 className="text-2xl font-bold text-white font-['Playfair_Display'] leading-snug">
                      {stage.title}
                    </h3>
                  </div>
                </div>

                {/* Description */}
                <p className="text-white/80 text-sm sm:text-base leading-relaxed font-['Montserrat'] mb-5 sm:mb-8 pl-0 sm:pl-[5.5rem] border-l-2 border-[#C5A880]/40 pl-4">
                  {stage.description}
                </p>

                {/* Points */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6">
                  {stage.points.map((point, pIdx) => (
                    <div
                      key={pIdx}
                      className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-xl sm:rounded-2xl p-4 sm:p-6"
                    >
                      <div className="flex items-center gap-3 mb-2 sm:mb-3">
                        <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                          <i className={`${point.icon} text-xl text-[#C5A880]`}></i>
                        </div>
                        <h4 className="text-sm font-bold text-white font-['Montserrat']">
                          {point.title}
                        </h4>
                      </div>
                      <p className="text-white/70 text-xs leading-relaxed font-['Montserrat']">
                        {point.text}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom accent */}
        <div className="mt-10 sm:mt-16 rounded-2xl sm:rounded-3xl bg-gradient-to-r from-[#1A2B4C] to-[#253D6B] p-6 sm:p-10 flex flex-col sm:flex-row items-center gap-5 sm:gap-8 text-center sm:text-left">
          <div className="flex-shrink-0 w-14 h-14 sm:w-20 sm:h-20 rounded-xl sm:rounded-2xl bg-[#C5A880]/20 border border-[#C5A880]/30 flex items-center justify-center">
            <i className="ri-calendar-check-line text-2xl sm:text-4xl text-[#C5A880]"></i>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-lg sm:text-2xl font-bold text-white font-['Playfair_Display'] mb-2 sm:mb-3 leading-snug">
              Всё это — каждый месяц, без вашего участия
            </h3>
            <p className="text-white/75 text-sm sm:text-base leading-relaxed font-['Montserrat']">
              Вы занимаетесь бизнесом, а мы — вашим сайтом. Ни одна задача не выпадет из виду. По итогам каждого месяца вы получаете отчёт о проделанной работе.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
